import { Badge } from '../../components/ui/badge';

export const EDITORIAL_STATUSES = ['DRAFT', 'AI_GENERATED', 'TO_REVIEW', 'APPROVED', 'PUBLISHED', 'ARCHIVED'];

const COLORS = {
  DRAFT: 'bg-slate-100 text-slate-600 border-slate-200',
  AI_GENERATED: 'bg-violet-50 text-violet-700 border-violet-200',
  TO_REVIEW: 'bg-amber-50 text-amber-700 border-amber-200',
  APPROVED: 'bg-blue-50 text-blue-700 border-blue-200',
  PUBLISHED: 'bg-emerald-50 text-emerald-700 border-emerald-200',
  ARCHIVED: 'bg-slate-100 text-slate-400 border-slate-200',
};

export function statusBadge(status) {
  return <Badge className={`${COLORS[status] || COLORS.DRAFT} border text-xs`}>{status}</Badge>;
}
